/**
 * Maximum length of a comment, mirroring the backend AddCommentRequest
 * `@length(min: 1, max: 4000)` constraint. The backend is the source of truth;
 * the client validates against this to fail fast.
 */
export const MAX_COMMENT_LENGTH = 4000;

/**
 * Request payload for adding a free-text comment to a review.
 * POST /lighthouse/reviews/{reviewId}/comment
 *
 * The review must be PENDING; the comment is recorded on the review's audit
 * trail (surfaced as the entry's `notes`). `reviewId` is a path parameter, so
 * only `comment` is sent in the body.
 */
export interface AddCommentRequest {
    reviewId: string;
    comment: string;
}
